import { getActions } from '../../../../../global';

import type { DropdownItem } from '../../../../ui/Dropdown';

import { MULTISEND_DAPP_URL } from '../../../../../config';
import { vibrate } from '../../../../../util/haptics';
import { getTranslation } from '../../../../../util/langProvider';
import { openUrl } from '../../../../../util/openUrl';
import { getHostnameFromUrl } from '../../../../../util/url';

export type MenuHandler = 'send' | 'multisend';

export const SEND_CONTEXT_MENU_ITEMS: DropdownItem<MenuHandler>[] = [{
  name: 'Send',
  fontIcon: 'menu-send',
  value: 'send',
}, {
  name: 'Multisend',
  fontIcon: 'menu-multisend',
  value: 'multisend',
}];

export function handleSendMenuItemClick(value: MenuHandler) {
  switch (value) {
    case 'send':
      vibrate();
      getActions().startTransfer();
      break;

    case 'multisend':
      vibrate();
      void openUrl(MULTISEND_DAPP_URL, {
        title: getTranslation('Multisend'),
        subtitle: getHostnameFromUrl(MULTISEND_DAPP_URL),
      });
      break;
  }
}
